













import Vue from 'vue'
import HomeNewTitle from '@/UI/Home/HomeNewTitle.vue'
import HomeNewContent from '@/UI/Home/HomeNewContent.vue'
export default Vue.extend({
  name: 'HomeNew',
  components: { HomeNewTitle, HomeNewContent },
  props:
  {
    nova: {
      type: Object,
      required: true
    }
  }
})
